import { FlaskConical } from 'lucide-react'

/**
 * Aviso para pantallas que todavía funcionan con datos de ejemplo porque su
 * backend no existe.
 *
 * Existe por una razón concreta: un dato inventado que se ve real es peor que
 * un error, porque nadie se entera y se toman decisiones con él. Mientras el
 * mock siga ahí, que al menos se note.
 *
 * Cuando la pantalla se conecte de verdad, se borra este banner junto con el
 * mock.
 */
const DatosDeEjemploBanner = ({ detalle }: { detalle?: string }) => (
  <div className="flex items-start gap-3 px-4 py-3 mb-6 bg-amber-50 border border-amber-200 rounded-lg">
    <FlaskConical className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
    <p className="text-sm text-amber-800">
      <span className="font-semibold">Datos de ejemplo.</span>{' '}
      {detalle ?? 'Esta pantalla todavía no está conectada al servidor, así que lo que ves no es información real.'}
    </p>
  </div>
)

export default DatosDeEjemploBanner
